export const selectProfilePictureLoading = (state) => state.app.profile.loading > 0;
